class SpinnerService {
  async allSppiners() {
    const res = await window.axios.get(`/api/v1/admin/spinner`);
    return res.data;
  }

  async giftById({ id }) {
    try {
      const res = await window.axios.get('/api/v1/admin/spinner/prize', { params: { id } });
      return res.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  async updateGift({ gift }) {
    try {
      const res = await window.axios.put('/api/v1/admin/spinner/prize', gift);
      return res.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  async deleteGift({ id }) {
    try {
      const res = await window.axios.delete(`/api/v1/admin/spinner/prize?id=${id}`);
      return res.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  async createGift({ gift }) {
    try {
      const res = await window.axios.post('/api/v1/admin/spinner/prize', gift);
      return res.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }
}

module.exports = SpinnerService;
